import React from "react";
import "./services.css";
import { BiCheck } from "react-icons/bi";

const Services = () => {
  return (
    <section id="services">
      <h5>What I Offer</h5>
      <h2>Services</h2>

      <div className="container services__container">
        <article className="service">
          <div className="service__head">
            <h3>App Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                Android and ios App Development with React Native.
              </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Deep analysis insight into requirements, needs & goals.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Pixel-perfect unique UI design for any type of App.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Responsive and User-friendly user interfaces.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>API Integration with third-party services or any other external functionality.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Business, Social networking or any type of App.</p>
            </li>
          </ul>
        </article>
        {/* END OF UI/UX */}
        <article className="service">
          <div className="service__head">
            <h3>Web Development</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Web application development with React & Node JS.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>React JS Full Stack Development using MERN stack.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Using React, React Hooks, React Redux, React Toolkit.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                REST APIs using Node JS, Express, and your choice of database.
              </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>
                ERP, CRM, Point of Sales (POS) and Inventory Management System.
              </p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Ecommerce & Business Software Development.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Unit Testing, Bug Fixing and Responsive Design.</p>
            </li>
          </ul>
        </article>
        {/* END OF WEB DEVELOPMENT */}
        <article className="service">
          <div className="service__head">
            <h3>Cyber Security</h3>
          </div>

          <ul className="service__list">
            <li>
              <BiCheck className="service__list-icon" />
              <p>Digital Forensics, Penetration Testing & Vulnerability Analysis.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Identify vulnerable systems & suggest to fix weaknesses.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Test and evaluate systems, networks, and digital assets for potential threats.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Develop, implement, and maintain security.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Monitor the latest news and threats in the security.</p>
            </li>
            <li>
              <BiCheck className="service__list-icon" />
              <p>Ethical Hacking & Cyber Security Awareness.</p>
            </li>
          </ul>
        </article>
        {/* END OF CONTENT CREATION */}
      </div>
    </section>
  );
};

export default Services;
